import {
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';

export const httpErrorInterceptor = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      let errorMessage = 'Ocurrió un error inesperado';

      if (error.error instanceof ErrorEvent) {
        // Error del lado del cliente
        errorMessage = `Error: ${error.error.message}`;
      } else {
        // Error del lado del servidor
        switch (error.status) {
          case 400:
            errorMessage = 'Solicitud inválida. Verifique los datos enviados.';
            break;
          case 401:
            errorMessage = 'No autorizado. Inicie sesión nuevamente.';
            break;
          case 403:
            errorMessage = 'Acceso denegado. No tiene permisos para esta acción.';
            break;
          case 404:
            errorMessage = 'Recurso no encontrado.';
            break;
          case 409:
            errorMessage = 'Conflicto. El recurso ya existe o ya fue procesado.';
            break;
          case 410:
            errorMessage = 'El recurso ha expirado.';
            break;
          case 422:
            errorMessage = 'Error de validación. Verifique los datos.';
            break;
          case 429:
            errorMessage = 'Demasiadas solicitudes. Intente más tarde.';
            break;
          case 500:
            errorMessage = 'Error interno del servidor. Intente nuevamente.';
            break;
          case 502:
            errorMessage = 'Servicio no disponible. Intente más tarde.';
            break;
          case 503:
            errorMessage = 'Servicio en mantenimiento. Intente más tarde.';
            break;
          case 504:
            errorMessage = 'Tiempo de espera agotado. Intente nuevamente.';
            break;
          default:
            errorMessage = error.error?.message || `Error ${error.status}: ${error.statusText}`;
        }
      }

      console.error('HTTP Error:', error);
      console.error('Error Message:', errorMessage);

      return throwError(() => error);
    })
  );
};
